import React from 'react';
import {
  Box,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';

export const DrivingExperienceStep: React.FC = () => {
  return (
    <Box sx={{ maxWidth: 600 }}>
      <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 2 }}>
        Radius of Experience
      </Typography>

      <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
        At least one employment record is required. If you do not have any experience to add,{' '}
        <Typography component="span" sx={{ textDecoration: 'underline' }}>
          at least one education program
        </Typography>{' '}
        is required.
      </Typography>

      <Box sx={{ mb: 4 }}>
        <Typography variant="body1" sx={{ mb: 3 }}>
          * Company
        </Typography>
        <TextField fullWidth placeholder="Enter company name" sx={{ backgroundColor: 'white' }} />
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="body1" sx={{ mb: 3 }}>
          * Country
        </Typography>
        <FormControl fullWidth>
          <InputLabel>Select Country</InputLabel>
          <Select label="Select Country" sx={{ backgroundColor: 'white' }}>
            <MenuItem value="CA">Canada</MenuItem>
            <MenuItem value="US">United States</MenuItem>
          </Select>
        </FormControl>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="body1" sx={{ mb: 3 }}>
          * Select province
        </Typography>
        <FormControl fullWidth>
          <InputLabel>Select Province</InputLabel>
          <Select label="Select Province" sx={{ backgroundColor: 'white' }}>
            <MenuItem value="AB">Alberta</MenuItem>
            <MenuItem value="BC">British Columbia</MenuItem>
            <MenuItem value="MB">Manitoba</MenuItem>
            <MenuItem value="NB">New Brunswick</MenuItem>
            <MenuItem value="NL">Newfoundland and Labrador</MenuItem>
            <MenuItem value="NS">Nova Scotia</MenuItem>
            <MenuItem value="ON">Ontario</MenuItem>
            <MenuItem value="PE">Prince Edward Island</MenuItem>
            <MenuItem value="QC">Quebec</MenuItem>
            <MenuItem value="SK">Saskatchewan</MenuItem>
            <MenuItem value="NT">Northwest Territories</MenuItem>
            <MenuItem value="NU">Nunavut</MenuItem>
            <MenuItem value="YT">Yukon</MenuItem>
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
};
